export default __webpack_public_path__ + "static/media/SuperSeva_Logo_white.3ccdd4a5.png";